import React from "react";
import "./Case.css";

const Case = () => {
  return (
    <div className="case">
      <div className="case__container">
        <div className="case__left">
          <img
            src="https://www.zazmic.com/wp-content/themes/zazmic/img/banner-shapes-webp.webp"
            alt="ai"
            style={{ width: "490px", height: "430px" }}
            className="case__img"
          />
        </div>
        <div className="case__right">
          <h1 className="case__title">Use Cases</h1>
          <p className="case__text">
          Here are some of the benefits of using Google Gen Ai for Content Management
          </p>
          <div className="case__list">
            <div className="case__list-block">
              <div className="case__list-dot" />
              <p className="case__list-item">
              Summarize financial documents to help you find relevant documents for your business.
              </p>
            </div>

            <div className="case__list-block">
              <div className="case__list-dot" />
              <p className="case__list-item">
              Summarize legal contracts to help legal teams quickly identify the key terms and conditions of the contract.
              </p>
            </div>
            <div className="case__list-block">
              <div className="case__list-dot" />
              <p className="case__list-item">
              Summarize research papers to help scientists and researchers keep up with the latest research.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Case;
